import { Injectable, Inject } from '@angular/core';
import { GroupTreeAttributeService } from '../odata-services';
import { GridDataService } from './core/griddata.service';
import { NotificationService } from '@progress/kendo-angular-notification';

@Injectable({
  providedIn: 'root'
})
export class GroupTreeAttributeDataService extends GridDataService {
    
  public odataService: GroupTreeAttributeService;
  
  
    constructor( @Inject(GroupTreeAttributeService) service: GroupTreeAttributeService, @Inject(NotificationService) notificationService?: NotificationService) { 
      super(service,null,notificationService); 
      this.odataService = service;
    }
}
